import { DisplayCapability } from '../../FrontApplet/Display/IDisplay';

export type DisplayRequests = DisplaySupportsRequest | DisplayGetCapabilitiesRequest;

export const DisplaySupportsRequest = 'sos.Monitoring.Display.DisplaySupportsRequest';
export interface DisplaySupportsRequest {
	type: typeof DisplaySupportsRequest;
	capability: string;
}

export const DisplaySupportsResult = 'sos.Monitoring.Display.DisplaySupportsResult';
export interface DisplaySupportsResult {
	type: typeof DisplaySupportsResult;
	supports: boolean;
}

export const DisplayGetCapabilitiesRequest = 'sos.Monitoring.Display.DisplayGetCapabilitiesRequest';
export interface DisplayGetCapabilitiesRequest {
	type: typeof DisplayGetCapabilitiesRequest;
}

export const DisplayGetCapabilitiesResult = 'sos.Monitoring.Display.DisplayGetCapabilitiesResult';
export interface DisplayGetCapabilitiesResult {
	type: typeof DisplayGetCapabilitiesResult;
	result: DisplayCapability[];
}
